import { __assign } from '../../_virtual/_tslib.js';
import { Theme as Theme$1 } from '../Input/Input.themes.js';

var Theme;
(function (Theme) {
  var remapInputTheme = function (inputLightOrDark) {
    return {
      selectBg: inputLightOrDark.inputBg,
      selectBorder: inputLightOrDark.inputBorder,
      selectFocusBg: inputLightOrDark.inputFocusBg,
      selectFocusBorder: inputLightOrDark.inputFocusBorder,
      selectHoverBg: inputLightOrDark.inputHoverBg,
      selectText: inputLightOrDark.inputText,
      selectPlaceholder: inputLightOrDark.inputPlaceholder,
      selectDisabledText: inputLightOrDark.inputDisabledText,
      selectInvalidBorder: inputLightOrDark.inputInvalidBorder
    };
  };
  Theme.getLight = function (primaryColor) {
    return __assign({}, remapInputTheme(Theme$1.getLight(primaryColor)));
  };
  Theme.getDark = function (primaryColor) {
    return __assign({}, remapInputTheme(Theme$1.getDark(primaryColor)));
  };
})(Theme || (Theme = {}));

export { Theme };
